import Cookies from 'js-cookie';

class PauHelpers {

    static normalize = ( _ => {
              var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
                  to   = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
                  mapping = {};

              for(var i = 0, j = from.length; i < j; i++ )
                  mapping[ from.charAt( i ) ] = to.charAt( i );

              return function( str ) {
                  var ret = [];
                  for( var i = 0, j = str.length; i < j; i++ ) {
                      var c = str.charAt( i );
                      if( mapping.hasOwnProperty( str.charAt( i ) ) )
                          ret.push( mapping[ c ] );
                      else
                          ret.push( c );
                  }
                  ret = ret.join( '' );

                  var specialChars = "!@#$^&%*()+=[]\/{}|:<>?.ç";

                  for( var l = 0, m = specialChars.length; l < m; l++ ) {
                      ret = ret.replace( new RegExp( "\\" + specialChars[l], 'gi' ), '' );
                  }

                  return ret;

              }

        })()

    static isFirefox() {

      if( navigator.userAgent.toLowerCase().indexOf( "firefox" ) >= 0 ) return true;

      return false;

    }

    static getSettingsCookies( key = null ) {

        let settings = Cookies.getJSON( "settings" );

        if( key ) {
            return settings[ key ];
        }

        return settings;

    }

}

export default PauHelpers;



// WEBPACK FOOTER //
// ./src/includes/PauHelpers.js